<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col md="3">
          <v-row>
            <v-col>
              <v-card shrink height="75vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>{{ $t('roles.label.roles') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_new_role"
                          v-on="on"
                          icon
                          @click="newRole"
                          color="primary"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('roles.label.createRole') }}</span>
                  </v-tooltip>
                </v-toolbar>
                <v-list max-height="65vh" style="overflow-y: auto">
                  <v-list-item-group v-model="selectedRoleIndex" color="primary">
                    <v-list-item
                        v-for="(role, i) in roles"
                        :key="i"
                        @mouseenter="overRoleName = role.rolename"
                        @mouseleave="overRoleName = null"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="role.label"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip bottom open-delay="600">
                          <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="role.predefined"
                                id="btn_delete_role"
                                v-on="on"
                                icon
                                @click.stop="maybeDeleteRole(role)"
                                color="primary"
                                :style="overRoleName === role.rolename ? '' : 'visibility: hidden'"
                            >
                              <v-icon>{{ role.predefined ? 'mdi-delete-off' : 'mdi-delete' }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('roles.label.deleteRole') }}</span>
                        </v-tooltip>
                      </v-list-item-action>
<!--                      <v-list-item-icon :style="overRoleName === role.rolename ? '' : 'visibility: hidden'">-->
<!--                        <v-icon>mdi-delete</v-icon>-->
<!--                      </v-list-item-icon>-->
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="selectedRole || createRole">
          <v-row>
            <v-col>
              <v-card shrink min-height="75vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>
                    {{ createRole ? $t('roles.label.newRole') : $t('roles.label.role', {role: selectedRole.label}) }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip v-if="!roleEdition" bottom open-delay="600">
                    <template v-if="!roleEdition" v-slot:activator="{ on }">
                      <v-btn
                          id="btn_show_all"
                          v-on="on"
                          icon
                          @click="showAllPermissions = !showAllPermissions"
                          color="primary"
                      >
                        <v-icon>{{ showAllPermissions ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ showAllPermissions ? $t('roles.label.hideAllPermissions') : $t('roles.label.showAllPermissions') }}
                    </span>
                  </v-tooltip>
                  <v-tooltip v-if="!roleEdition" bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_edit_role"
                          v-on="on"
                          icon
                          :disabled="!createRole && selectedRole.predefined"
                          @click="editRole"
                          color="primary"
                      >
                        <v-icon>{{ !createRole && selectedRole.predefined ? 'mdi-pencil-off' : 'mdi-pencil' }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('roles.label.edit') }}</span>
                  </v-tooltip>
                  <div v-if="roleEdition">
                    <v-btn
                        id="btn_cancel_role"
                        text
                        @click="cancelEdition()"
                    >
                      {{ $t('app.button.cancel') }}
                    </v-btn>
                    <v-btn
                        id="btn_save_role"
                        color="primary"
                        @click="saveRole()"
                        :disabled="!validRoleData"
                    >
                      {{ $t('app.button.save') }}
                    </v-btn>
                  </div>
                </v-toolbar>
                <v-row>
                  <v-col>
                    <v-card shrink flat height="20vh">
                      <v-form ref="form" v-model="validRoleData">
                        <v-container>
                          <v-row>
                            <v-col id="role_label" md="12">
                              <v-text-field
                                  v-model="roleLabel"
                                  :rules="labelRules"
                                  :label="$t('app.label.name')"
                                  :readonly="!roleEdition"
                                  :class="roleEdition ? '' : 'removeBorder'"
                              ></v-text-field>
                              <div v-if="!roleEdition && selectedRole" class="caption">
                                {{ selectedRole.description }}
                              </div>
                            </v-col>
                            <v-col v-if="createRole && isPlatformUserAdmin" md="6">
                              <v-select
                                  v-model="newRoleGroup"
                                  :items="groups"
                                  :label="$t('createProject.fields.createInGroup')"
                                  clearable
                                  @click:clear="newRoleGroup = null"
                                  item-text="label"
                                  item-value="name"
                              ></v-select>
                            </v-col>
                            <v-col
                                v-if="createRole && isPlatformUserAdmin"
                                md="6"
                                id="assignable"
                            >
                              <v-checkbox
                                  :disabled="newRoleGroup != null"
                                  v-model="assignableByPlateformUserAdminOnly"
                                  :label="$t('roles.label.assignableByPlateformUserAdminOnly')"
                              ></v-checkbox>
                            </v-col>
                            <v-col
                                v-if="!roleEdition && !selectedRole.predefined"
                                md="6"
                                id="role_createdBy"
                            >
                              <v-text-field
                                  v-model="selectedRole.createdBy"
                                  :label="$t('app.label.createdBy')"
                                  readonly
                                  :disabled="roleEdition"
                                  class="removeBorder"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                v-if="!roleEdition && !selectedRole.predefined"
                                md="6"
                                id="role_createdAt">
                              <v-text-field
                                  v-model="humanCreatedAt"
                                  :label="$t('app.label.createdDate')"
                                  readonly
                                  :disabled="roleEdition"
                                  class="removeBorder"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card shrink flat height="40vh">
                      <v-toolbar flat dense>
                        <v-toolbar-title>{{ $t('roles.label.generalPermissions') }}</v-toolbar-title>
                      </v-toolbar>
                      <v-list
                          flat
                          subheader
                          max-height="35vh"
                          style="overflow-y: auto"
                      >
                        <v-list-item-group v-model="permissions.general.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.general.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.general.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card shrink flat height="40vh">
                      <v-toolbar flat dense>
                        <v-toolbar-title>{{ $t('roles.label.uiPermissions') }}</v-toolbar-title>
                      </v-toolbar>
                      <v-list
                          flat
                          subheader
                          max-height="35vh"
                          style="overflow-y: auto"
                      >
                        <v-list-item-group v-model="permissions.ui.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.ui.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.ui.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action
                                  :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card shrink flat height="40vh">
                      <v-toolbar flat dense>
                        <v-toolbar-title>{{ $t('roles.label.componentsPermissions') }}</v-toolbar-title>
                      </v-toolbar>
                      <v-list
                          flat
                          subheader
                          max-height="35vh"
                          style="overflow-y: auto"
                      >
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.engines.values.length !== 0 || permissions.engines.selectedIndexes.length !== 0">
                          {{ $t('roles.label.engines') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.engines.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.engines.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.engines.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.converters.values.length !== 0 || permissions.converters.selectedIndexes.length !== 0">
                          {{ $t('roles.label.converters') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.converters.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.converters.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.converters.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.languageGuessers.values.length !== 0 || permissions.languageGuessers.selectedIndexes.length !== 0">
                          {{ $t('roles.label.languageGuessers') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.languageGuessers.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.languageGuessers.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.languageGuessers.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.segmenters.values.length !== 0 || permissions.segmenters.selectedIndexes.length !== 0">
                          {{ $t('roles.label.segmenters') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.segmenters.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.segmenters.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.segmenters.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.vectorizers.values.length !== 0 || permissions.vectorizers.selectedIndexes.length !== 0">
                          {{ $t('roles.label.vectorizers') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.vectorizers.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.vectorizers.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.vectorizers.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.formatters.values.length !== 0 || permissions.formatters.selectedIndexes.length !== 0">
                          {{ $t('roles.label.formatters') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.formatters.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.formatters.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.formatters.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.annotators.values.length !== 0 || permissions.annotators.selectedIndexes.length !== 0">
                          {{ $t('roles.label.annotators') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.annotators.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.annotators.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.annotators.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.processors.values.length !== 0 || permissions.processors.selectedIndexes.length !== 0">
                          {{ $t('roles.label.processors') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.processors.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.processors.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.processors.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                        <v-subheader v-if="showAllPermissions || roleEdition && permissions.termImporters.values.length !== 0 || permissions.termImporters.selectedIndexes.length !== 0">
                          {{ $t('roles.label.termImporters') }}
                        </v-subheader>
                        <v-list-item-group v-model="permissions.termImporters.selectedIndexes" multiple>
                          <v-list-item
                              v-for="(permission, i) in permissions.termImporters.values"
                              :key="permission.value"
                              :disabled="!roleEdition"
                              v-show="showAllPermissions || roleEdition || permissions.termImporters.selectedIndexes.indexOf(i) !== -1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action :style="showAllPermissions || roleEdition ? 'visibility: visible' : 'visibility: hidden'">
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ nameMode ? permission.value : permission.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <DeleteConfirmDialog
        v-if="confirmDeleteRole"
        idHint="usersRole"
        :title="$t('roles.label.confirmDeleteTitle')"
        :html="deletedRole != null ? $t('roles.label.confirmDeleteMessage', {role: this.deletedRole.label}) : ''"
        @yes="doDeleteRole()"
        @no="dontDeleteRole()"
    ></DeleteConfirmDialog>
  </div>
</template>

<script>
import DeleteConfirmDialog from "../utils/DeleteConfirmDialog";
import {openRoleAdmin, openRoleAdminAndSelectRole} from "@/routes/userAdminRoutes";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import {mapProperty} from "@/utils/vuexx";
import moment from "moment";
import {decodeParams} from "@/routes/pathParams";

export default {
  components: {
    DeleteConfirmDialog,
  },
  data() {
    return {
      showAllPermissions: false,
      deletedRole: null,
      confirmDeleteRole: false,
      selectedRoleIndex: null,
      overRoleName: null,
      newRoleLabel: null,
      newRoleAssignableByPlateformUserAdminOnly: true,
      newRoleGroup: null,
      validRoleData: true,
      labelRules: [
        v => !!v || this.$i18n.t("roles.label.nonEmptyRoleName"),
        v =>
            (v && v.length <= 40) ||
            this.$i18n.t("createProject.errors.nameLength", {count: 40})
      ],
      maxUsersRules: [
        v => !!v || this.$i18n.t("app.message.required"),
        v =>
            /^(0|-?[1-9]\d*)$/.test(v) ||
            this.$i18n.t("roles.label.mustBeInteger")
      ],
    }
  },
  mounted() {
    this.selectedRoleIndex = null
    const self = this
    const mount = async function () {
      await self.getRolesPermissionsGroups()
      self.selectRoleByParams(self.$route.params.selectionParams)
    }
    mount()
  },
  watch: {
    '$route.params.selectionParams': function (value) {
      this.selectRoleByParams(value)
    },
    selectedRoleIndex: function (value) {
      if (value != null) {
        const selectedRole = this.roles[value]
        openRoleAdminAndSelectRole(selectedRole.rolename)
      } else {
        openRoleAdmin(null)
      }
    },
    role: function (value) {
      if (!value)
        this.selectedRoleIndex = null
      else
        this.cancelEdition()
    }
  },
  computed: {
    ...mapState(["nameMode"]),
    ...mapState("auth", {loggedUser: "user"}),
    ...mapGetters("auth", ["isPlatformUserAdmin"]),
    ...mapState("roles", [
      "roleEdition",
      "groups",
      "roles",
      "role",
      "users",
      "permissions",
      "roleEdition",
      "createRole",
    ]),
    ...mapGetters("roles", ["currentPermissions"]),
    selectedRole: mapProperty("roles", "role"),
    humanCreatedAt() {
      moment.locale(this.$i18n.locale);
      return this.selectedRole ? moment(this.selectedRole.createdAt).fromNow() : ""
    },
    roleLabel: {
      get() {
        return this.selectedRole ? (this.roleEdition ? this.newRoleLabel : this.selectedRole.label) : ""
      },
      set(value) {
        this.newRoleLabel = value
      }
    },
    assignableByPlateformUserAdminOnly: {
      get() {
        return this.newRoleGroup ? false : this.newRoleAssignableByPlateformUserAdminOnly
      },
      set(value) {
        this.newRoleAssignableByPlateformUserAdminOnly = value
      }
    },
  },
  methods: {
    ...mapMutations("roles", ["setRole", "beginEdition", "endEdition"]),
    ...mapActions("roles", ["getRolesPermissionsGroups", "getRole", "getRoleUsers", "updateRole", "addRole", "deleteRole", "getPermissions"]),
    selectRoleByParams(params) {
      // this is required because of the UserAdmin tabs (sharing the same route)
      if (!this.$route.path.startsWith("/admin/roles"))
        return
      if (params) {
        const selectionParams = decodeParams(params)
        if (selectionParams.rolename) {
          this.selectRole(selectionParams.rolename)
        } else {
          this.selectRole(null)
        }
      } else {
        this.selectRole(null)
      }
    },
    async selectRole(rolename) {
      if (rolename != null) {
        const role = await this.getRole(rolename)
        // get role users (don't await)
        await this.getRoleUsers(rolename)
        this.newRoleLabel = role.label
        const index = this.roles.findIndex(role => role.rolename === rolename)
        // also select the role in the list 
        // but don't do it (to prevent watch loop?) if it is already the case
        if (index !== -1 && this.selectedRoleIndex !== index)
          this.selectedRoleIndex = index
      } else {
        this.selectedRole = null
        this.newRoleLabel = null
        // also unselect the role in the list 
        // but don't do it (to prevent watch loop?) if it is already the case
        if (this.selectedRoleIndex != null)
          this.selectedRoleIndex = null
      }
    },
    editRole() {
      this.newRoleLabel = this.selectedRole.label
      this.beginEdition(false)
    },
    newRole() {
      this.newRoleLabel = ""
      this.newRoleAssignableByPlateformUserAdminOnly = true
      this.newRoleGroup = null
      this.beginEdition(true)
    },
    maybeDeleteRole(role) {
      this.deletedRole = role
      this.confirmDeleteRole = true
    },
    dontDeleteRole() {
      this.deletedRole = null
      this.confirmDeleteRole = false
    },
    doDeleteRole() {
      try {
        this.deleteRole(this.deletedRole.rolename)
      } finally {
        this.confirmDeleteRole = false
      }
    },
    cancelEdition() {
      this.endEdition(true)
    },
    async saveRole() {
      let newRolename;
      let success = false
      try {
        const newPermissions = [...this.currentPermissions].sort()
        if (this.createRole) {
          // if user is not a platform user admin, create the role in its group
          const forcedGroupName = !this.loggedUser.permissions.includes("assignRole:*") ? this.loggedUser.groups[0] : null
          const addRole = {
            role: {
              label: this.newRoleLabel,
              permissions: newPermissions
            },
            restricted: forcedGroupName ? false : this.assignableByPlateformUserAdminOnly,
            groupName: forcedGroupName ? forcedGroupName : this.newRoleGroup
          }
          const role = await this.addRole(addRole)
          newRolename = role.rolename
        } else {
          const currentPermissions = [...this.selectedRole.permissions].sort()
          const update = {}
          if (this.newRoleLabel !== this.role.label)
            update.label = this.newRoleLabel
          if (JSON.stringify(newPermissions) !== JSON.stringify(currentPermissions))
            update.permissions = newPermissions
          if (Object.keys(update).length !== 0)
            await this.updateRole({rolename: this.selectedRole.rolename, update})
        }
        success = true
      } finally {
        try {
          if (success) {
            if (this.createRole) {
              await this.getRolesPermissionsGroups();
              await this.getRole(this.selectedRole.rolename)
              const index = this.roles.findIndex(role => role.rolename === newRolename)
              if (index !== -1)
                this.selectedRoleIndex = index
            } else {
              this.endEdition(!success)
              await this.getRole(this.selectedRole.rolename)
            }
          }
        } finally {
          this.endEdition(!success)
        }
      }
    },
  }
}
</script>

<style>
.removeBorder > .v-input__control > .v-input__slot::after {
  border-style: none !important;
}

.removeBorder > .v-input__control > .v-input__slot::before {
  border-style: none !important;
}
</style>